import React from 'react';
import Button from '../Button/Button';
import styles from './NetworkError.module.scss';

const NetworkErrorDom = ($$) => {
  return (
    <div className={styles.networkError}>
      <div className={styles.bgImg} />
      <div className={styles.title}>你的网络出现了问题</div>
      <div className={styles.subTitle}>稍后请刷新</div>
      <div className={styles.refresh}>
        <Button
          title="刷新"
          className={styles.refreshBtn}
          onClick={() => {
            $$.retry();
          }}
        />
      </div>
    </div>
  );
};

const NetworkError = (props) => {
  if (props.error) return <NetworkErrorDom {...props} />;
  if (props.timedOut) return <NetworkErrorDom {...props} />;
  return null;
};

export default NetworkError;
